module.exports = __webpack_public_path__ + "img/V-R-135-load-standup-base.91fa2755.png";